import { createSlice } from '@reduxjs/toolkit';

const initialManageAppsState = {
  form_new_app: false,
  user: {
    isPublisher: false,
  },
};

const manageAppsSlice = createSlice({
  name: 'manageApps',
  initialState: initialManageAppsState,
  reducers: {
    changeUserRole: (state, action) => {
      state.user.isPublisher = action.payload;
    },
    formNewAppIsChanged: (state, action) => {
      state.form_new_app = action.payload;
    },
  },
});

export const manageApps_action = manageAppsSlice.actions;
export default manageAppsSlice.reducer;
